<template>
  <v-content class="candidate opportunities apply-page">
    <v-container grid-list-lg fluid style="max-width: 900px;">
      <ApplicationForm
        v-if="opportunity && opportunity.id"
        :opportunity="opportunity"
        style="margin: auto"
      />
    </v-container>
  </v-content>
</template>

<script>
// Components
import ApplicationForm from '@/components/candidate/applications/ApplicationForm'

// Vue Component
export default {
  components: { ApplicationForm },

  created() {
    this.$store.dispatch('opportunities/fetch', this.id).then(() => {
    })
  },

  props: { id: String },

  computed: {
    opportunity() {
      return this.$store.getters['opportunities/find'](this.id)
    },
  },
}
</script>
